module.exports = __webpack_public_path__ + "static/media/cancelCalendar.6324f1aa.svg";